import { List, Skeleton } from "@mui/material";

const ClientLayoutSkeleton = () => {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            {/* Header Skeleton */}
            <div style={{ height: 64, background: '#e0e0e0', padding: '0 24px' }}>
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    height: '100%'
                }}>
                    <Skeleton variant="rectangular" width={120} height={32} />
                    <div style={{ display: 'flex', gap: 16 }}>
                        <Skeleton variant="circular" width={40} height={40} />
                        <Skeleton variant="rectangular" width={100} height={32} />
                    </div>
                </div>
            </div>

            {/* Main Content Area */}
            <div style={{ display: 'flex', flex: 1 }}>
                {/* Sidebar Skeleton */}
                <div style={{
                    width: 240,
                    background: '#f5f5f5',
                    padding: 14,
                    borderRight: '1px solid #e0e0e0'
                }}>

                    {[...Array(14)]?.map((a, index) => (
                        <List
                            key={index}
                            sx={{
                                padding: "10px"
                            }}>
                            <Skeleton
                                sx={{
                                    margin: "0px",
                                    borderRadius: "10px"
                                }}
                                variant="rectangular"
                                width="100%"
                                height={35}
                            />
                        </List>
                    ))}
                </div>


                {/* Dashboard Content */}
                <div style={{ padding: 24, flex: 1 }}>
                    {/* Picture Board Section */}
                    <div style={{ marginBottom: 32 }}>
                        <Skeleton variant="text" width={150} height={32} style={{ marginBottom: 16 }} />

                        {/* User and Date */}
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 16 }}>
                            <Skeleton variant="circular" width={24} height={24} />
                            <Skeleton variant="text" width={100} height={20} />
                            <Skeleton variant="text" width={100} height={20} />
                        </div>

                        {/* Stats Cards */}
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 16, marginBottom: 24 }}>
                            {['Expenses', 'Timesheets'].map((item) => (
                                <div key={item} style={{
                                    padding: 16,
                                    border: '1px solid #e0e0e0',
                                    borderRadius: 4,
                                    height: 120
                                }}>
                                    <Skeleton variant="text" width="60%" height={24} style={{ marginBottom: 16 }} />
                                    <Skeleton variant="text" width="30%" height={32} style={{ marginBottom: 8 }} />
                                    <Skeleton variant="text" width="80%" height={20} />
                                </div>
                            ))}
                        </div>

                        {/* Single Card */}
                        <div style={{
                            padding: 16,
                            border: '1px solid #e0e0e0',
                            borderRadius: 4,
                            maxWidth: 300,
                            height: 100
                        }}>
                            <Skeleton variant="text" width="30%" height={32} style={{ marginBottom: 8 }} />
                            <Skeleton variant="text" width="80%" height={20} />
                        </div>
                    </div>

                    {/* Applications Section */}
                    <div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16 }}>
                            <Skeleton variant="text" width={150} height={32} />
                            <Skeleton variant="text" width={200} height={20} />
                        </div>

                        {/* Support Requests */}
                        <Skeleton variant="text" width={150} height={32} style={{ marginTop: 24, marginBottom: 16 }} />
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                            {[...Array(3)].map((_, i) => (
                                <Skeleton
                                    key={i}
                                    variant="rectangular"
                                    height={56}
                                    style={{ borderRadius: 4 }}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ClientLayoutSkeleton;
